module.exports = __webpack_public_path__ + "static/img/home-2.3f4569fa.jpg";